module.exports = __webpack_public_path__ + "9a032837e91227a38fe7c675945d2204.jpg";